(function ($) 
{
    var addedMarkers = [];
    var mc;
    var userMarker;
    var old_lat = 0;
    var old_lng = 0;

    function new_map($el) 
    {
        var $markers = $el.find('.marker');
        var args = {
            zoom: 19,
            center: new google.maps.LatLng(0, 0),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: [
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#e9e9e9"
                        },
                        {
                            "lightness": 17
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#f5f5f5"
                        },
                        {
                            "lightness": 20
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": 17
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": 29
                        },
                        {
                            "weight": 0.2
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": 18
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": 16
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#f5f5f5"
                        },
                        {
                            "lightness": 21
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#dedede"
                        },
                        {
                            "lightness": 21
                        }
                    ]
                },
                {
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": 16
                        }
                    ]
                },
                {
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "saturation": 36
                        },
                        {
                            "color": "#333333"
                        },
                        {
                            "lightness": 40
                        }
                    ]
                },
                {
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#f2f2f2"
                        },
                        {
                            "lightness": 19
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#fefefe"
                        },
                        {
                            "lightness": 20
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#fefefe"
                        },
                        {
                            "lightness": 17
                        },
                        {
                            "weight": 1.2
                        }
                    ]
                }
            ]
        };
        var map = new google.maps.Map($el[0], args);
        map.markers = [];
        $markers.each(function () 
        {
            add_marker($(this), map);
        });
        addedMarkers = map.markers;
        center_map(map);
        current_window = null;
        add_cluster(map, map.markers);
        show_user_position(map);

        google.maps.event.addListener(map, 'zoom_changed', function() { 
            var zoomLevel = map.getZoom(); 
            if (zoomLevel >= 20) 
            { 
                map.setZoom(20); 
            } 
        }); 

        google.maps.event.addListenerOnce(map, 'idle', function(){
            toggleMapVisibility("on");
        });

        google.maps.event.addListener(mc, 'clusteringend', function()
        {
            //console.log("Map Rebuilt");
        });

        return map;
    }


    function show_user_position(map) 
    {

        var user_lat = getSimpleValue("user_set_lat");
        var user_lng = getSimpleValue("user_set_lng");

        if (!user_lat || user_lat == "" || user_lat === undefined)
        {
            user_lat = getSimpleValue("user_lat");
            user_lng = getSimpleValue("user_lng");
        }
        var image = '/app/themes/hailstone/img/layout/home-icon.png';

        var marker_id = 'map_location_for_user';
        if (user_lng && user_lat)
        {
            if (userMarker)
            {
                userMarker.setMap(null);
                delete userMarker;
            }
            var myLatLng = new google.maps.LatLng(user_lat, user_lng);

            userMarker = new google.maps.Marker({
                position: myLatLng,
                map: map,
                icon: image,
                id: marker_id,
            });
        }

        return map;
    }


    function add_marker($marker, map) 
    {
        var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));

        /*if ($marker.attr('data-image'))
        {
            var image = '/app/themes/hailstone/img/layout/home-pin.png';
            var marker = new google.maps.Marker({
                position: latlng,
                map: map,
                icon: image,
                id: $marker.attr('id'),
            });
        }
        else
        {*/
            var image2 = '/app/themes/hailstone/img/layout/solicitor-icon.png';
            var marker = new google.maps.Marker({
                position: latlng,
                map: map,
                icon: image2,
                id: $marker.attr('id'),
            });
        //}
        map.markers.push(marker);

        if ($marker.html()) 
        {

            var infowindow = new google.maps.InfoWindow(
            {
                content: $marker.html(),
                //disableAutoPan: true,
            });

            google.maps.event.addListener(marker, 'click', function () 
            {
                if(current_window != null) 
                {
                    current_window.close(); 
                }
                infowindow.open(map, marker);
                current_window = infowindow;
            });
        }
    }


    function center_map(map) 
    {
        var lng_lats = [];
        var bounds = new google.maps.LatLngBounds();
        $.each(map.markers, function (i, marker) {
            var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
            lng_lats.push( [marker.position.lat(), marker.position.lng()]);
            bounds.extend(latlng);
        });

        //console.log( lng_lats );

        if (map.markers.length == 1) {
            map.setCenter(bounds.getCenter());
            map.setZoom(14);
            // map.setZoom(16);
        }
        else {
            //console.log( 'in the else');
            map.setCenter(bounds.getCenter());
            // map.fitBounds(bounds);
            var zoom = map.getZoom();
            map.setZoom(zoom > 8 ? 6 : zoom);
        }
    }

    function add_cluster(map, markers)
    {
        mc = new MarkerClusterer(map, markers, 
        {
            gridSize: 40, 
            maxZoom: 20, 
            zoomOnClick: true, 
            minimumClusterSize: 4,
            imagePath: "/app/themes/hailstone/img/layout/m/m",
            ignoreHidden: true
        });

    }

    /*
        solicitor filter tools
    */

    // toggle the form options
    $('.solicitor-finder-toggles .do-toggle').click(function(e)
    {
        e.preventDefault();

        var currentlyActive = $(this).parent().hasClass("active"); // we allow complete hide
        $(".solicitor-finder-toggles li").removeClass("active");
        $(".solicitor-filter").addClass("hide");
        if (!currentlyActive)
        {
            var show = $(this).data('exchange');
            $("#" + show).removeClass("hide");
            $(this).parent().addClass("active");
        }
        return false;
    });


    // toggle the form options
    $('.reset-solicitor-filters').click(function(e)
    {
        e.preventDefault(); 

        // reset the location to initial (geo) value
        $("#user_set_lat").html(""); 
        $("#user_set_lng").html("");  
        $('#location-input-info').html("");
        $('#location-input-on').addClass("hide");

        $('input[type=checkbox][name=has_accessibility_statement]').each(function () {
            $(this).removeAttr('checked');
        })
        $('input[type=radio][name=category_parent]').each(function () {
            $(this).prop('checked', false);
        })
        $("#solicitor-finder-child-group").addClass("hide");
        $("input[type=radio][name=location_radius][value=1000]").prop('checked', true);

        $( "#solicitor-finder-child-list" ).val("");
        $( "#solicitor_search_keywords" ).val("");
        $( '#search_address' ).val("");

        var defaultLoc = $("#default-user-location-info").html();

        $('#user-location-message').html(defaultLoc);
        localStorage.removeItem('storedLocVars');
        localStorage.removeItem('storedMapVars');
        localStorage.removeItem('storedMapPage');


        doSolicitorUpdate();
        //return false;
    });

    // hide and show solicitor cards based on form values
    // all form values that matter, have been given the non-styled class of solicitor-finder-update to enable a single sweep

    $( '.solicitor-finder-update' ).change(function ()
    {
        localStorage.removeItem('storedMapPage')
        doSolicitorUpdate();
    });

    $( '#solicitor_search_keywords' ).keyup(function ()
    {
        if ( $(this).val().length > 2 || $(this).val().length == 0)
        {
            localStorage.removeItem('storedMapPage')
            doSolicitorUpdate();
        }
    });



    $(document).on('click','.switch-map-tab',function(e)
    {
        //e.preventDefault();
        var el_id = $( this ).data('switchto') || null; // the panel we are turning on 

        if (el_id)
        {

            var container = $(el_id).parents('.card-section'); // the tab we are tuning on
            $(container).find( ".tabs-title" ).removeClass( "is-active" );
            $(container).find( ".tabs-title a" ).attr("aria-selected","false");
            $(container).find( ".tabs-panel" ).removeClass( "is-active" );

            $(el_id).addClass("is-active");
            $(this).parent().addClass("is-active");
            $(this).attr("aria-selected","true");

            return false;
        
        }
    });

    function doSolicitorUpdate()
    {

        toggleMapVisibility("off");
        // get user data
        var location_choice = $( "input[type=radio][name=location_choice]:checked" ).val();
        var radius = $( "input[type=radio][name=location_radius]:checked" ).val();
        var accessibility = $( "input[type=checkbox][name=has_accessibility_statement]:checked" ).val();
        var category = $( "input[type=radio][name=category_parent]:checked" ).val();
        var child_category = $( "#solicitor-finder-child-list" ).val();
        var keywords = $( "#solicitor_search_keywords" ).val();

        // assess use data whether it needs factored in or not
        var do_location_choice = null;
        var do_radius = (radius && radius != undefined) ? radius : null;
        var do_accessibility = (accessibility && accessibility != undefined) ? accessibility : null;
        var do_keywords = (keywords && keywords != undefined) ? keywords.toLowerCase() : null;
        var do_category = null; // categories are odder. If child cat is set, then use it only
        if (category && category != undefined )
        {
            do_category = category;
        }
        if (category && category == "civil" && child_category && child_category != undefined && child_category != "" )
        {
            do_category = child_category;
        }

        //console.log (location_choice + " ~ " + radius  + " ~ " + accessibility + " ~ " + category  + " ~ " + child_category  + " ~ " + keywords);

        var now_showing = 0;
        var active_ids = [];
        
        $('.solicitor-text-entry').each( function(i)
        {
            var marks_required = 0; // how many checks to make
            var marks_gained = 0; // how many checks passed

            // a. check category / subcategory exists
            if (do_category)
            {
                marks_required++;
                var c_slugs = $(this).data('category-slugs').split(','); // convert this data attribute into an array
                c_slugs.forEach( function(entry) // for each item in the attributes arrray, 
                {
                    var test = entry.trim(); // trim it
                    if (test == do_category) //if there's a match in the tags selected array
                    {
                        marks_gained++;
                    }
                });
            }
            // b. check accessibility
            if ( (marks_gained == marks_required) && do_accessibility)
            {
                marks_required++;
                var test = $(this).data('accessibility');
                if (test == "1")
                {
                    marks_gained++;
                }
            }
            // c. check radius
            if ((marks_gained == marks_required) && do_radius)
            {
                marks_required++;
                var test = $(this).data('distance');
                if (test && test < do_radius )
                {
                    marks_gained++;
                }
            }
            // d. check keywords
            if ((marks_gained == marks_required) && do_keywords)
            {
                marks_required++;
                var test = $(this).data('keywords').toLowerCase();

                if (test.indexOf(do_keywords) >= 0)
                {
                    marks_gained++;
                }
                //console.log( test + " ~ " + do_keywords + " ~ " + test.indexOf(do_keywords) );
            }
            // e. check location ?? maybe not

            var sibling_card = $(this).data('sibling'); // find its twin card on the Google map

            if (marks_gained == marks_required) // if this matches all criteria, then show
            { 
                active_ids.push(sibling_card);
                $(this).removeClass("hide");
                now_showing++;
            }
            else // else add hide
            {
                $(this).addClass("hide");   
            }

           

        });
        //active_ids.push("map-card-start"); // add back in our "location" pin

        var search_address = $("#search_address").val();

        var storedMapVars = 
        {
            location_choice: location_choice,
            radius: radius,
            accessibility: accessibility,
            category: category,
            child_category: child_category,
            keywords: keywords,
            search_address: search_address
        }

        //console.log(storedMapVars);

        localStorage.setItem('storedMapVars', JSON.stringify(storedMapVars));
        toggleMarkers(active_ids, runup, now_showing, sortDivsDistance); // set google maps to rebuild results
        

    }

    // we need to re-apply the distances before doing anything else
    function runup(now_showing, cb) 
    {

        toggleMapVisibility("on");
        if (cb)
        {
            cb();
        }
        $("#solicitor-results-count").html(now_showing); // update the HTML counter

        $("#solicitor-listings").pagify(5, ".solicitor-text-entry:not(.hide)");
        buildAssociatedData();
        show_user_position(map);

    };

    function toggleMapVisibility(onOrOff)
    {
        if (onOrOff == "off")
        {
            $("#map-listings").addClass("hide");
            $("#signal-holder").removeClass("hide"); 
        }
        else
        {
            $("#signal-holder").addClass("hide"); 
            $("#map-listings").removeClass("hide");     
        }
    }

    function sortDivsDistance()
    {
        var products = $('.solicitor-text-entry');
        products.sort(function(a, b){ return $(a).data("distance")-$(b).data("distance")});
        $("#solicitor-listings").html(products);

    }

    function toggleMarkers(haystack, callback, extra, extra2) 
    {

        var in_count = 0;
        var out_count = 0;
        //mc.clearMarkers();
        for (i in addedMarkers) 
        {
            var needle = addedMarkers[i].id;
            var test = haystack.indexOf(needle);
            var visibility = (test > -1) ? true : false;
            if (visibility)
            {
                in_count++;
            }
            else
            {
                out_count++;
            }

            addedMarkers[i].setVisible(visibility);
        }
        mc.setIgnoreHidden(true);
        mc.repaint();
        callback(extra, extra2);
        //console.log("haystack:" + haystack.length + "in: " + in_count + ", out: " + out_count);

    }

    $(".form_category_parent").change(function()
    {
        var choice = $( "input[type=radio][name=category_parent]:checked" ).val();

        if (choice == "civil")
        {
            $("#solicitor-finder-child-group").removeClass("hide");
        }
        else
        {
            $("#solicitor-finder-child-group").addClass("hide");
        }
    });


    var timeout_address = null;
    var geocoder = new google.maps.Geocoder();

    $("#search_address").keyup(function(e) 
    {
        e.preventDefault();
        clearTimeout(timeout_address);
        timeout_address = setTimeout(function() 
        {
            manualLocation();
        }, 1000);
    });

    function manualLocation()
    {

        var use_address = $("#search_address").val() + ", Scotland";
        var final_address = "";
        var final_string = "";

        geocoder.geocode( { 'address': use_address }, function(results, status) {

          if (status == google.maps.GeocoderStatus.OK) 
          {
              localStorage.removeItem('storedMapPage')
              var city = "";
              var area = "";
              var postcode = "";
              var country = "";
              
              final_address = results[0].formatted_address;

              if (final_address != "Scotland, UK") // make sure we don't return ", Scotland" as the location
              {

                for (var ac = 0; ac < results[0].address_components.length; ac++) 
                {
                    var component = results[0].address_components[ac];
                    //console.log(component.types[0] + " " + component.short_name);
                    switch(component.types[0]) 
                    {
                      case 'locality':  
                        city = component.short_name;
                        break;
                      case 'postal_town':  
                        city = component.short_name;
                        break;
                      case 'administrative_area_level_1':
                        area = component.short_name;
                        break;
                      case 'postal_code':
                        postcode = component.short_name;
                        break;
                      case 'country':
                        country = component.short_name;
                        break;

                    }
                };
                var custom_lat = results[0].geometry.location.lat();
                var custom_lng  = results[0].geometry.location.lng();
                //console.log( "Where? ", use_address, city, area, postcode, country, "Set by User / Google");

                // update hidden fields
                $("#user_set_lat").html(custom_lat); 
                $("#user_set_lng").html(custom_lng);  

                // change the user messages and reflow the data
                final_string = "Your location has been manually set as: <b>" + final_address + "</b>.";
                $("#user-location-message").html(final_string);
                buildAssociatedData();
                show_user_position(map);

                var storedLocVars = 
                {
                    final_string: final_string,
                    user_set_lng: custom_lng,
                    user_set_lat: custom_lat
                }

                localStorage.setItem('storedLocVars', JSON.stringify(storedLocVars));

              }
              else
              {
                  final_string = "This location cannot be found.";
                  //localStorage.removeItem('storedLocVars');
              }
          }

          else
          {
              final_string = "This location cannot be found."
              //localStorage.removeItem('storedLocVars');
          }
          $('#location-input-info').html(final_string);

      });

        
    }


    // changes all the listings on demand
    function buildAssociatedData()
    {
        /*
            Solicitor distance calculations
        */
        var user_lat = getSimpleValue("user_set_lat");
        var user_lng = getSimpleValue("user_set_lng");

        if (!user_lat || user_lat == "" || user_lat === undefined)
        {
            user_lat = getSimpleValue("user_lat");
            user_lng = getSimpleValue("user_lng");
        }

        if (user_lng && user_lat)
        {
            $(".distance-to").each(function(i, obj)
            {
                var lat = $(this).data('lat'); 
                var lng = $(this).data('lng'); 
                var distance = getDistanceBetween(user_lat, user_lng, lat, lng);

                $(this).html(" - " + distance + " miles");
                //$(this).closest('solicitor-text-entry').data('distance', distance); // doesn't work aftr dom loads
                $(this).closest("div").attr("data-distance", distance); 

            });
            sortDivsDistance();
            $("#solicitor-listings").pagify(5, ".solicitor-text-entry:not(.hide)");
        }
    }

    // initialise the map
    var map = null;
    $(document).ready(function () 
    {
        $('.acf-map-solicitors').each(function () 
        {
            map = new_map($(this));
            buildAssociatedData();

            // a2. restore all user form settings
            var retrievedObject = localStorage.getItem('storedMapVars');
            if (retrievedObject)
            {
                var previous_settings =  JSON.parse(retrievedObject);
                if (previous_settings)
                {

                    /*var storedMapVars = 
                    {
                        location_choice: location_choice,
                        radius: radius,
                        accessibility: accessibility,
                        category: category,
                        child_category: child_category,
                        keywords: keywords,
                        search_address: search_address
                    }*/
                    
                    if (previous_settings['accessibility'] && previous_settings['accessibility'] == 1)
                    {
                        $('input[type=checkbox][name=has_accessibility_statement]').each(function () {
                            $(this).attr( 'checked', true )
                        });
                    }
                    if (previous_settings['category'] && previous_settings['category'] != "" && previous_settings['category'] != undefined)
                    {
                        $('input[type=radio][name=category_parent][value="'+ previous_settings['category'] +'"]').each(function () {
                            $(this).prop('checked', true);
                        });
                        if (previous_settings['category'] == "civil")
                        {
                            $("#solicitor-finder-child-group").removeClass("hide");
                        }
                    }
                    if (previous_settings['child_category'] && previous_settings['child_category'] != "" && previous_settings['child_category'] != undefined)
                    {
                        $('#solicitor-finder-child-list option[value=' + previous_settings['child_category'] + ']').attr('selected','selected');

                    }
                    if (previous_settings['radius'] && previous_settings['radius'] != "" && previous_settings['radius'] != undefined)
                    {
                        $('input[type=radio][name=location_radius][value="'+ previous_settings['radius'] +'"]').each(function () {
                            $(this).prop('checked', true);
                        });
                    }
                    $( "#solicitor_search_keywords" ).val(previous_settings['keywords']);
                    $( '#search_address' ).val(previous_settings['search_address']);
                    //doSolicitorUpdate();
                }
            }

            // a2. restore manual locations
            var retrievedObject2 = localStorage.getItem('storedLocVars');
            if (retrievedObject2)
            {
                var previous_settings2 =  JSON.parse(retrievedObject2);
                if (previous_settings2)
                {

                    /*var storedLocVars = 
                    {
                        final_string: final_string,
                        user_set_lng: user_set_lng,
                        user_set_lat: user_set_lat
                    }*/
                    
                    if (previous_settings2['user_set_lat'] && previous_settings2['user_set_lat'] != "" && previous_settings2['user_set_lat'] != undefined)
                    {
                        $("#user_set_lat").html(previous_settings2['user_set_lat']); 
                        $("#user_set_lng").html(previous_settings2['user_set_lng']);  
                        $('#location-input-on').removeClass("hide");
                        $("#user-location-message").html(previous_settings2['final_string']);

                    }
                }
            }
            if (retrievedObject2 || retrievedObject)
            {
                clearTimeout(timeout_address);
                timeout_address = setTimeout(function() 
                {
                    buildAssociatedData();
                    show_user_position(map);
                    doSolicitorUpdate(); // rebuild the map

                }, 500);
            }

        });

    });

})(jQuery);



/*!
 * jQuery TextChange Plugin
 * http://www.zurb.com/playground/jquery-text-change-custom-event
 *
 * Copyright 2010, ZURB
 * Released under the MIT License
 */
 (function(a){a.event.special.textchange={setup:function(){a(this).data("lastValue",this.contentEditable==="true"?a(this).html():a(this).val());a(this).bind("keyup.textchange",a.event.special.textchange.handler);a(this).bind("cut.textchange paste.textchange input.textchange",a.event.special.textchange.delayedHandler)},teardown:function(){a(this).unbind(".textchange")},handler:function(){a.event.special.textchange.triggerIfChanged(a(this))},delayedHandler:function(){var c=a(this);setTimeout(function(){a.event.special.textchange.triggerIfChanged(c)},
 25)},triggerIfChanged:function(a){var b=a[0].contentEditable==="true"?a.html():a.val();b!==a.data("lastValue")&&(a.trigger("textchange",[a.data("lastValue")]),a.data("lastValue",b))}};a.event.special.hastext={setup:function(){a(this).bind("textchange",a.event.special.hastext.handler)},teardown:function(){a(this).unbind("textchange",a.event.special.hastext.handler)},handler:function(c,b){b===""&&b!==a(this).val()&&a(this).trigger("hastext")}};a.event.special.notext={setup:function(){a(this).bind("textchange",
 a.event.special.notext.handler)},teardown:function(){a(this).unbind("textchange",a.event.special.notext.handler)},handler:function(c,b){a(this).val()===""&&a(this).val()!==b&&a(this).trigger("notext")}}})(jQuery);